const modelProduct = data => ({
  id: data.id,
  external_id: data.external_id,
  name: data.name?.toLowerCase(),
  assets: data.assets?.raw
})

export default modelProduct
